import { useEventListener } from './event';

export function useOnWindowResize(callback: (event: Event) => void) {
    useEventListener(window, 'resize', (event: Event) => {
        callback(event);
    });
}
